var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGloeilamp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Laag_2",
    "data-name": "Laag 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,18.5H7a.5.5,0,0,1-.5-.5V13.5a.5.5,0,0,1,1,0v4h4v-4a.5.5,0,0,1,1,0V18A.5.5,0,0,1,12,18.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.22,21a3,3,0,0,1-3-3,.5.5,0,0,1,1,0,2,2,0,1,0,4,0,.5.5,0,0,1,1,0A3,3,0,0,1,9.22,21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.22,2a.47.47,0,0,1-.35-.15l-1-1a.48.48,0,0,1,0-.7.48.48,0,0,1,.7,0l1,1a.48.48,0,0,1,0,.7A.47.47,0,0,1,4.22,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.22,2a.47.47,0,0,1-.35-.15.48.48,0,0,1,0-.7l1-1a.48.48,0,0,1,.7,0,.48.48,0,0,1,0,.7l-1,1A.47.47,0,0,1,14.22,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.22,14a.47.47,0,0,1-.35-.15.48.48,0,0,1,0-.7l1-1a.49.49,0,1,1,.7.7l-1,1A.47.47,0,0,1,3.22,14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.22,14a.47.47,0,0,1-.35-.15l-1-1a.49.49,0,1,1,.7-.7l1,1a.48.48,0,0,1,0,.7A.47.47,0,0,1,15.22,14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5,7.5H.5a.5.5,0,0,1,0-1h1a.5.5,0,0,1,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5,7.5h-1a.5.5,0,0,1,0-1h1a.5.5,0,0,1,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,14.5H7a.5.5,0,0,1-.5-.5V12.8a4.2,4.2,0,0,1-1.69-1.16A6.73,6.73,0,0,1,2.79,7,6.27,6.27,0,0,1,4.62,2.4a6.52,6.52,0,0,1,9.2,0,6.72,6.72,0,0,1,2,4.59A6.27,6.27,0,0,1,14,11.6a5.24,5.24,0,0,1-1,.71l-.43.27V14A.5.5,0,0,1,12,14.5Zm-4.5-1h4V12.43c0-.44.41-.68.93-1a4.89,4.89,0,0,0,.82-.56A5.28,5.28,0,0,0,14.79,7a5.68,5.68,0,0,0-1.68-3.9,5.5,5.5,0,0,0-7.78,0A5.28,5.28,0,0,0,3.79,7a5.68,5.68,0,0,0,1.68,3.9A3.2,3.2,0,0,0,7.14,12a.51.51,0,0,1,.36.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39,10.33A.49.49,0,0,1,6,10.18,4.49,4.49,0,0,1,6,3.82a.5.5,0,0,1,.71,0,.51.51,0,0,1,0,.71,3.48,3.48,0,0,0,0,4.94.51.51,0,0,1,0,.71A.51.51,0,0,1,6.39,10.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.72,16.94a.59.59,0,0,1-.22-.05l-5-2.44a.5.5,0,1,1,.44-.9l5,2.44a.5.5,0,0,1,.23.67A.51.51,0,0,1,11.72,16.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.82,18.5a.54.54,0,0,1-.21-.05l-4.11-2a.5.5,0,0,1,.44-.9l4.1,2a.5.5,0,0,1,.23.67A.48.48,0,0,1,10.82,18.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGloeilamp);
export default __webpack_public_path__ + "static/media/gloeilamp.5d3d6c61f1f6581ff44108c57fd1746c.svg";
export { ForwardRef as ReactComponent };